import React from 'react'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Popconfirm } from 'antd'
import { DropdownMenu } from 'modules/core/components'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'

const TableActions = ({ onConfirmDelete, onCancelDelete, visible, onClickEdit, onClickDelete }) => {
  const { t } = useTranslation()
  return (
    <Popconfirm
      title={t('QUESTION_POPCONFIRM_DELETE_TITLE')}
      okText={t('ACTION_DELETE')}
      cancelText={t('ACTION_CANCEL')}
      onConfirm={onConfirmDelete}
      onCancel={onCancelDelete}
      placement="bottomRight"
      visible={visible}
    >
      <DropdownMenu
        title={t('ACTION_MORE')}
        menu={_.compact([
          {
            title: t('ACTION_EDIT'),
            icon: <EditOutlined />,
            onClick: onClickEdit,
          },
          {
            title: t('ACTION_DELETE'),
            icon: <DeleteOutlined />,
            onClick: onClickDelete,
          },
        ])}
      />
    </Popconfirm>
  )
}

export default TableActions
